/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function WarningXlarge(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'WarningXlarge',
      'aria-hidden': true,
      focusable: false,
      width:  38 * scale,
      height: 34 * scale,
      viewBox: '0 0 38 34',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"m36.835 31.108-16.68-29.46A1.3 1.3 0 0 0 19.025 1c-.47 0-.903.247-1.135.65L1.215 31.107c-.226.392-.224.874.01 1.263a1.3 1.3 0 0 0 1.12.63h33.36c.46 0 .886-.24 1.12-.63.23-.388.234-.87.01-1.262M19 29a2 2 0 1 1 0-4 2 2 0 0 1 0 4m1-7h-2l-1-10h4z"}))
}
